import { defer, EMPTY, fromEvent, merge, repeat } from "rxjs";
import { filter, debounceTime, share } from "rxjs/operators";
function createRefocus$({
  debounceMs = 150,
  includeOnline = true,
  windowRef = typeof window !== "undefined" ? window : void 0,
  documentRef = typeof document !== "undefined" ? document : void 0
} = {}) {
  return defer(() => {
    if (!windowRef || !documentRef) return EMPTY;
    const focus$ = fromEvent(windowRef, "focus");
    const visible$ = fromEvent(documentRef, "visibilitychange").pipe(filter(() => documentRef.visibilityState === "visible"));
    const online$ = includeOnline ? fromEvent(windowRef, "online") : EMPTY;
    return merge(focus$, visible$, online$).pipe(
      debounceTime(debounceMs),
      share()
    );
  });
}
function refetchOnFocus(opts) {
  const refocus$ = createRefocus$(opts);
  return (source$) => source$.pipe(
    repeat({ delay: () => refocus$ })
  );
}
export {
  createRefocus$,
  refetchOnFocus
};
